import { routeImplementation } from '@shared/infrastructure/router/routeImplementation';

interface RouteRepository {
  getParams: (
    pathWithSlug: string,
    pathname: string
  ) => Record<string, string> | null;
  buildRoute: (pathWithSlug: string, params: Record<string, string>) => string;
  shouldMatchRoute: (pathWithSlug: string, pathname: string) => boolean;
}

export const routeRepository: RouteRepository = {
  getParams: (pathWithSlug, pathname) =>
    routeImplementation.getParams(pathWithSlug, pathname),
  buildRoute: (pathWithSlug, params) =>
    routeImplementation.buildRoute(pathWithSlug, params),
  shouldMatchRoute: (pathWithSlug, pathname) =>
    routeImplementation.shouldMatchRoute(pathWithSlug, pathname)
};
